<div dwType="primary" dw-popover [(dwVisible)]="visible" (dwVisibleChange)="change($event)" dwTrigger="click"
  [dwContent]="contentTemplate" dwPlacement="bottomLeft" style="color: #2196f3;">
  {{mper[0]}}{{mper[1] ? ('(' + mper[1] + ')') : ''}}
</div>

<ng-template #contentTemplate>
  <div>
    <div *ngFor="let item of infoList; index as index">
      <div class="fx_list">
        <span>{{item.field_name}}:</span> <span>{{item.field_value}}</span>
      </div>
    </div>
    <div style="color: #2196f3;">更多日志</div>
  </div>
</ng-template>

<!-- <div>test</div> -->